import * as Sentry from '@sentry/vue'

export interface FeedbackReplayCapture {
  begin(): void
  submit(): void
  discard(): void
}

export function createFeedbackReplayCapture(enabled: boolean): FeedbackReplayCapture {
  let buffering = false

  function getReplay() {
    return enabled ? Sentry.getReplay() : undefined
  }

  return {
    begin() {
      const replay = getReplay()
      if (!replay || buffering) return
      replay.startBuffering()
      buffering = true
    },
    submit() {
      const replay = getReplay()
      if (!replay || !buffering) return
      void replay.flush({ continueRecording: false })
      buffering = false
    },
    discard() {
      const replay = getReplay()
      if (!replay || !buffering) return
      void replay.stop()
      buffering = false
    },
  }
}
